// ============================================================================
// ENTITY (COMPANY) SERVICE
// ============================================================================

import { get, post, patch, del } from '../client/axiosClient';
import { entityEndpoints } from '../endpoints/entity.endpoints';
import { buildEndpointWithQuery } from '../endpoints/base.endpoints';
import type {
  ApiResponse,
  PaginatedResponse,
  ID,
} from '../types';
import { transformPaginatedResponse } from '../types/common.types';
import type {
  Entity,
  CreateEntityRequest,
  UpdateEntityRequest,
  EntityFilterParams,
} from '../types/entity.types';

class EntityService {
  async getAll(params?: EntityFilterParams): Promise<PaginatedResponse<Entity>> {
    const endpoint = params
      ? buildEndpointWithQuery(entityEndpoints.list(), params)
      : entityEndpoints.list();
    const response = await get(endpoint);
    return transformPaginatedResponse<Entity>(response.data);
  }

  async getById(id: ID): Promise<ApiResponse<Entity>> {
    const response = await get<ApiResponse<Entity>>(entityEndpoints.getById(id));
    return response.data;
  }

  async create(payload: CreateEntityRequest): Promise<ApiResponse<Entity>> {
    const response = await post<ApiResponse<Entity>>(entityEndpoints.create(), payload);
    return response.data;
  }

  async update(id: ID, payload: UpdateEntityRequest): Promise<ApiResponse<Entity>> {
    const response = await patch<ApiResponse<Entity>>(entityEndpoints.update(id), payload);
    return response.data;
  }

  async delete(id: ID): Promise<ApiResponse<void>> {
    const response = await del<ApiResponse<void>>(entityEndpoints.delete(id));
    return response.data;
  }
}

export const entityService = new EntityService();
export default entityService;
